import _defineProperty from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectSpread from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _toConsumableArray from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";

var _RESOURCE_PROCESSOR_M;

import orderby from "lodash.orderby"; //Limitless imports

import { log as pilog } from "../../utils/Logging";
import { uniqueArrayBy } from "../../utils/array-helper/ArrayHelper";
export var TEXT_ENCODING = "text";
export var BUFFER_ENCODING = "buffer";
export var BASE64_ENCODING = "base64";
export var HTML_ENCODING = "html";
export var UI_LABELS_JSON = {
  name: "ui_labels.json",
  encoding: TEXT_ENCODING,
  stateKey: "uilabels",
  defaultContent: null
};
export var THEME_JSON = {
  name: "theme.json",
  encoding: TEXT_ENCODING,
  stateKey: "theme",
  defaultContent: null
};
export var UPGRADE_JSON = {
  name: "upgrade.json",
  encoding: TEXT_ENCODING,
  ignoreCache: true,
  stateKey: "upgradeContent",
  defaultContent: null
};
export var COACHING_SCREENS_JSON = {
  name: "coachingScreens.json",
  encoding: TEXT_ENCODING,
  stateKey: "coachingSlides",
  defaultContent: [],
  formatRemoteContent: function formatRemoteContent(content, defaultCoachingJSON) {
    if (content) {
      try {
        // merge the platform data with our defaults, so CST only have to update what they want to change.
        var platformContents = content;

        var defaultCoachingSlides = _toConsumableArray(defaultCoachingJSON);

        return platformContents.length > 0 ? platformContents : defaultCoachingSlides;
      } catch (error) {
        var log = pilog.getLogger("RemoteResourceUtil formatRemoteContent");
        log.error("Invalid JSON for ".concat(COACHING_SCREENS_JSON, ", default coaching slides will be used"), error);
        return defaultCoachingJSON;
      }
    } else {
      //this is here for when we have locale a) setup with coaching slides, then switch to locale b) which doesn't have slides
      if (defaultCoachingJSON) {
        return defaultCoachingJSON;
      } else {
        return [];
      }
    }
  }
};
export var WHITE_LIST_CONTENT = {
  name: "whiteList.txt",
  encoding: TEXT_ENCODING,
  processor: HTML_ENCODING,
  stateKey: "whiteListResource",
  defaultContent: "<p> To join Limitless you need to be invited. If you have been invited but are having trouble registering, please email our friendly team at <a href='https://www.limitlesstech.com/expert-portal#ambassador-form' target='_blank'>https://www.limitlesstech.com/expert-portal#ambassador-form</a> </p>"
};
export var EXPERT_TERMS = {
  name: "terms/expert_terms.html",
  encoding: BUFFER_ENCODING
};
export var PRIVACY_POLICY = {
  name: "terms/expert_privacy_policy.html",
  encoding: BUFFER_ENCODING
};
export var CODE_OF_CONDUCT = {
  name: "terms/code_of_conduct.html",
  encoding: BUFFER_ENCODING
};
export var TUTORIAL_JSON = {
  name: "helpTutorials.json",
  encoding: TEXT_ENCODING
};
export var TOWNS_JSON = {
  name: "towns.json",
  encoding: TEXT_ENCODING,
  stateKey: "towns",
  defaultContent: []
};
export var HOW_IT_WORKS_JSON = {
  name: "llm_how_it_works.json",
  encoding: TEXT_ENCODING,
  stateKey: "hiwSlides",
  formatRemoteContent: function formatRemoteContent(content) {
    // if there is no hiwcards exist then present default hiwcards
    return orderby(content, "id", "asc");
  }
};
export var HOW_IT_WORKS = {
  name: "how_this_works.txt",
  encoding: TEXT_ENCODING,
  processor: HTML_ENCODING,
  stateKey: "learnmoreContent",
  defaultContent: ""
};
export var MARKETING_CARDS = {
  name: "marketing_cards.json",
  encoding: TEXT_ENCODING,
  stateKey: "marketingContent",
  formatRemoteContent: function formatRemoteContent(content, defaultContent) {
    var newMarketingContent = []; //map over the platform content

    content.map(function (platformContent) {
      //find the local content for this card (if available)
      var card = defaultContent.find(function (content) {
        return content.id === platformContent.id;
      }); //push the card to the new marketing content

      newMarketingContent.push(_objectSpread({}, card, {}, platformContent));
    }); //merge the cards array together in case more are defined in platform

    var finalMarketingContent = uniqueArrayBy([].concat(newMarketingContent, _toConsumableArray(defaultContent)), "id");
    return finalMarketingContent;
  }
};
export var DISCLAIMER = {
  name: "disclaimer.txt",
  encoding: TEXT_ENCODING,
  processor: HTML_ENCODING,
  stateKey: "disclaimerContent",
  defaultContent: ""
};
export var REPORT = {
  name: "report.txt",
  encoding: TEXT_ENCODING,
  processor: HTML_ENCODING,
  stateKey: "reportContent",
  defaultContent: "<h4>Would you like to report this question?</h4>"
};
export var BRAND_IMG = {
  name: "brand.png",
  encoding: BASE64_ENCODING,
  processor: BASE64_ENCODING,
  stateKey: "brandImage",
  //this is a 1px x 1px white pixel
  defaultContent: "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7",
  formatRemoteContent: function formatRemoteContent(content) {
    return "data:image/png+xml;base64,".concat(content);
  }
};
export var STATIC_TEXT_EVENT_MAPPING = {
  name: "staticTextEventMapping.json",
  encoding: TEXT_ENCODING,
  stateKey: "staticTextEventMapping",
  defaultContent: [],
  formatRemoteContent: function formatRemoteContent(content) {
    return content.eventTextMapping;
  }
};
export var CRUI_APP_RESOURCES = [UI_LABELS_JSON, THEME_JSON, HOW_IT_WORKS, MARKETING_CARDS, DISCLAIMER, BRAND_IMG, REPORT];
export var LLM_RESOURCES = [UI_LABELS_JSON, THEME_JSON, HOW_IT_WORKS_JSON, UPGRADE_JSON];
export var EWA_APP_RESOURCES = [UI_LABELS_JSON, THEME_JSON, UPGRADE_JSON, COACHING_SCREENS_JSON, WHITE_LIST_CONTENT, TOWNS_JSON];
export var EMA_APP_RESOURCES = [UI_LABELS_JSON, UPGRADE_JSON, THEME_JSON, COACHING_SCREENS_JSON, WHITE_LIST_CONTENT, TOWNS_JSON]; //not currently used, but we should

export var ASYNC_EMA_APP_RESOURCES = [THEME_JSON, COACHING_SCREENS_JSON, WHITE_LIST_CONTENT, TOWNS_JSON];
export var PORTAL_RESOURCES = [UI_LABELS_JSON, THEME_JSON];
export var TERMS_RESOURCES = [EXPERT_TERMS, PRIVACY_POLICY]; //this is here for coaching card editor. really we should load the locale specific towns when editing cards

export var CROWD_MANAGER_RESOURCES = [UI_LABELS_JSON, TOWNS_JSON];
/**
 * An array of JSON resources to be processed
 *
 * @param {array} resourceArray
 */

export var jsonResourceProcessor = function jsonResourceProcessor(platformResource) {
  var log = pilog.getLogger("RemoteResourceUtil jsonResourceProcessor");
  var content = platformResource.content,
      fileName = platformResource.fileName,
      location = platformResource.location,
      resourceName = platformResource.resourceName,
      applicationName = platformResource.applicationName;
  var resource = {
    resourceName: resourceName ? resourceName : fileName,
    fileName: fileName ? fileName : resourceName,
    location: location,
    applicationName: applicationName
  };

  if (platformResource.content) {
    try {
      resource.content = JSON.parse(content);
    } catch (error) {
      log.error("Failed to process ".concat(fileName ? fileName : resourceName, " %o"), error);
    }
  }

  return resource;
};
/**
 * An array of buffer stream resources to be processed
 *
 * @param {array} resourceArray
 */

export var bufferResourceProcessor = function bufferResourceProcessor(platformResource) {
  var log = pilog.getLogger("RemoteResourceUtil bufferResourceProcessor");
  var resource = {
    resourceName: platformResource.resourceName,
    location: platformResource.location,
    fileName: platformResource.fileName
  };

  try {
    if (platformResource.content) {
      var bytes = new Uint8Array(platformResource.content.data);
      var decoder = new TextDecoder("utf-8");
      resource.content = decoder.decode(bytes);
    }
  } catch (error) {
    log.error("Unable to decode ".concat(platformResource.resourceName, " from the platform content %o"), error);
  }

  return resource;
};
export var RESOURCE_PROCESSOR_MAP = (_RESOURCE_PROCESSOR_M = {}, _defineProperty(_RESOURCE_PROCESSOR_M, TEXT_ENCODING, jsonResourceProcessor), _defineProperty(_RESOURCE_PROCESSOR_M, BUFFER_ENCODING, bufferResourceProcessor), _defineProperty(_RESOURCE_PROCESSOR_M, HTML_ENCODING, function (resource) {
  return resource;
}), _defineProperty(_RESOURCE_PROCESSOR_M, BASE64_ENCODING, function (resource) {
  return resource;
}), _RESOURCE_PROCESSOR_M);